import React from 'react';
import { SectionHeading } from './SectionHeading';
import { TornEdge } from './TornEdge';
import { Reveal } from './Reveal';
const blocks = [{
  title: 'Orientación espiritual para situaciones sentimentales',
  text: 'Consultas personalizadas para conversar sobre lo que estás viviendo en tu vida sentimental desde una perspectiva espiritual tradicional.'
}, {
  title: 'Prácticas tradicionales relacionadas con el amor y las relaciones',
  text: 'Rituales y prácticas ancestrales vinculadas al amor y a los lazos afectivos, adaptadas a las circunstancias de cada persona.'
}, {
  title: 'Rituales tradicionales para situaciones de pareja',
  text: 'Acompañamiento espiritual y rituales tradicionales para quienes atraviesan situaciones de pareja y desean explorarlas desde lo espiritual.'
}];
export function LoveGuidance() {
  return <section aria-labelledby="amor-title" className="relative overflow-hidden bg-plum-deep py-20 sm:py-28" data-id="element-113" data-mp="33lmzb5rveb7o">
      <TornEdge colorClassName="bg-plum-deep" data-id="element-114" data-mp="7x2qtgqv1llv" />
      <div className="relative mx-auto w-full max-w-5xl px-5 sm:px-8" data-id="element-115" data-mp="7wb7p5eg9gch">
        <Reveal data-id="element-116" data-mp="cul41jbwumzo">
          <SectionHeading id="amor-title" folio="Sección IV · Expediente del amor" title="Orientación Espiritual para Situaciones Sentimentales" align="left" data-id="element-117" data-mp="cu2z7yb6n0g5" />
        </Reveal>

        <ol className="mt-14" data-id="element-118" data-mp="3lbfvm2n9ckyg">
          {blocks.map((block, index) => <Reveal as="li" key={block.title} delay={index * 0.1} data-id="element-119" data-mp="3ldagxi2fyf32" data-mpi={index}>
              <div className="relative overflow-hidden border-t border-gold/35 py-9 last:border-b last:border-gold/35 sm:py-11" data-id="element-120" data-mp="3qblr5twnerlt">
                <span aria-hidden="true" className="pointer-events-none absolute -top-2 right-2 select-none font-display text-[5.5rem] font-light leading-none text-gold/10 sm:right-6 sm:text-[8rem]" data-id="element-121" data-mp="3uaulazvlorhw">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <div className="relative max-w-2xl" data-id="element-122" data-mp="ds2y73osmv1o">
                  <span className="font-folio text-[0.62rem] uppercase tracking-[0.28em] text-gold/80" data-id="element-123" data-mp="dqi8brdfc0a5">
                    Folio {String(index + 1).padStart(2, '0')}
                  </span>
                  <h3 className="mt-4 font-display text-lg font-normal uppercase leading-snug tracking-[0.08em] text-paper sm:text-2xl" data-id="element-124" data-mp="ngkzrn4wd66d">
                    {block.title}
                  </h3>
                  <p className="mt-4 text-sm leading-relaxed text-body sm:text-[0.98rem]" data-id="element-125" data-mp="3qze6ph366wrk">
                    {block.text}
                  </p>
                </div>
              </div>
            </Reveal>)}
        </ol>
      </div>
    </section>;
}